import EmblaCarousel from 'embla-carousel';
import debounce from 'lodash.debounce';
import $ from 'jquery';

export default class Carousel {
    constructor(props) {
        this.rootEl = $('#'+props.id);
        this.container = $(this.rootEl.get(0)?.closest(props.containerSelector));
        this.controlsHolder = $(props.controlsSelector, this.container);
        this.prevControl = $(`[${props.controlAttr}="prev"]`, this.controlsHolder);
        this.nextControl = $(`[${props.controlAttr}="next"]`, this.controlsHolder);
        this.bootstrapContainer = $('.container');
        this.debounceTime = props.resizeDebounce || 200;

        $(window).on('resize', debounce(() => this.updateLastSlideOffset(), this.debounceTime));

        $(document)
            .on('mousedown', '#'+props.id, this.handleMouseDown)
            .on('mouseup', '#'+props.id, this.handleMouseUp)
        ;

        this.prevControl.on('click', () => this.carousel?.scrollPrev());
        this.nextControl.on('click', () => this.carousel?.scrollNext());
    }

    handleMouseDown = () => this.rootEl.css('cursor', 'grabbing');

    handleMouseUp = () => this.rootEl.css('cursor', 'grab');

    setContainerOffset() {        
        if (this.container.length && this.bootstrapContainer.length) {
            const paddingX = parseInt(this.bootstrapContainer.css('padding-left'));
            const containerOffsetLeft = this.bootstrapContainer.offset().left + paddingX;

            this.container.css('margin-left', containerOffsetLeft + 'px');
            this.controlsHolder.css('right', containerOffsetLeft + 'px');
            
            return containerOffsetLeft
        }

        return 0
    };

    updateLastSlideOffset() {
        if (this.carousel) {
            const offsetLeft = this.setContainerOffset();
            const slides = this.carousel.slideNodes();
            const lastSlide = $(slides[slides.length - 1]);
            
            lastSlide.css('margin-right', offsetLeft + 'px');
            this.carousel.reInit();
        }
    };

    handleSlidesInView = carousel => {
        const canNext = carousel.canScrollNext();
        const canPrev = carousel.canScrollPrev();

        this.nextControl.prop('disabled', !canNext);
        this.prevControl.prop('disabled', !canPrev);
    }

    init() {
        if (this.rootEl.length && !this.carousel) {
            this.carousel = EmblaCarousel(this.rootEl.get(0), {
                loop: false,
                align: 'start',
                containScroll: true,
                dragFree: true,
            });

            this.updateLastSlideOffset();

            this.carousel.on('slidesInView', this.handleSlidesInView)
        }

        return this;
    };
}